import { StyleRules, Theme, withStyles, WithStyles } from "@material-ui/core/styles";

export const createStyles = <S extends StyleRules>(styles: S) => styles;

export type DefaultStyle = {
    root: {
        display: 'flex',
        flexDirection: 'column',
        flexWrap: 'wrap',
    },
    input: {
        margin: string | number
    },
    container: {
        margin: string | number
    }
}

export const defaultStyles = ({spacing}: Theme) => createStyles({
    root: {
        display: 'flex',
        flexDirection: 'column',
        flexWrap: 'wrap',
    },
    input: {
        margin: spacing.unit
    },
    container: {
        margin: spacing.unit * 2
    }
});


export const withDefaultStyles = withStyles(defaultStyles);

export type WithDefaultStyles =  WithStyles<"input"|"root" | "container">


// WEBPACK FOOTER //
// ./src/utils/createStyles.ts